import { BiBulb, BiCheck, BiErrorAlt } from "react-icons/bi";
import { IInputValidationControllerReturn } from "./InputValidationController";
import { EInputValidationResultType } from "./enums/InputValidationEnums";
import { IInputValidationItemController, IInputValidationItemProps } from "./interfaces/InputValidationInterfaces";

export interface IValidateProps {
  //ivc: IInputValidationControllerReturn | null, 
  value?: string,
  c: IInputValidationItemController,
  props: IInputValidationItemProps,
  //ignoreBlur?: boolean
}

export default class InputValidationFun {

  public static getTextClassByType(ivc: IInputValidationControllerReturn): string {
    switch (ivc.validResultType) {
      case EInputValidationResultType.Hint: return "text-gray-500";
      case EInputValidationResultType.Error: return "text-red-500";
      default: return "text-red-400";
    }
  }

  public static getIconByType(ivc: IInputValidationControllerReturn): JSX.Element {
    switch (ivc.validResultType) {
      case EInputValidationResultType.Error: return <div className="text-red-500"> <BiErrorAlt size={17} /></div>
      case EInputValidationResultType.Hint: return <div className="text-gray-500"> <BiBulb size={17} /></div>
      default: return <></>;
    }
  }

  public static getIsValidIcon(ivc: IInputValidationControllerReturn): JSX.Element {
    if(ivc.validResultType != EInputValidationResultType.Valid) return <></>
    return <div className={"text-green-500"}><BiCheck size={20} /></div>
  }
  
  
}